export default "__VITE_ASSET__DVkG95ne__"